import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksPt = () => {
    return <HowStartpageWorks languageCode="pt" />
}

export default HowStartpageWorksPt
